// React i hooks
import { NavLink } from "react-router-dom";
import { memo } from "react";

// Helpers
import { classNames, useTranslate } from "helpers";

// Moduli specifični za projekt
import { Routes as CalculationRoutes } from "ui/modules/calculation/navigation";

// Tipovi i konstante
import { TabMenuProps } from "./types";

const TabMenu: React.FC<TabMenuProps> = () => {

  const { t } = useTranslate();

  return (
    <>
      <div className="flex border-b border-slate-200 bg-white">
        <NavLink
          to={CalculationRoutes.CalculationSettingPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.calculation.setting.detail.tab.basic")}
        </NavLink>
        <NavLink
          to={CalculationRoutes.CalculationVehicleGroupSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.calculation.setting.detail.tab.vehiclegroups")}
        </NavLink>
        <NavLink
          to={CalculationRoutes.CalculationLeasingSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.calculation.setting.detail.tab.leasing")}
        </NavLink>
        <NavLink
          to={CalculationRoutes.CalculationResidualValueSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.calculation.setting.detail.tab.residualvalue")}
        </NavLink>
        <NavLink
          to={CalculationRoutes.CalculationTireSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.calculation.setting.detail.tab.tire")}
        </NavLink>

        <NavLink
          to={CalculationRoutes.CalculationTehnicalInspectionSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.calculation.setting.detail.tab.tehnicalinspection")}
        </NavLink>
        <NavLink
          to={CalculationRoutes.CalculationAnnualTaxSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.calculation.setting.detail.tab.annualtax")}
        </NavLink>
        <NavLink
          to={CalculationRoutes.CalculationVehicleInsuranceSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
          {t("admin.calculation.setting.detail.tab.vehicleinsurance")}
        </NavLink>
        <NavLink
          to={CalculationRoutes.CalculationTollSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
           {t("admin.calculation.setting.detail.tab.toll")}
        </NavLink>
        <NavLink
          to={CalculationRoutes.CalculationVehicleServicesSearchPageRouter}
          className={({ isActive }: { isActive: boolean }) =>
            classNames(
              isActive
                ? "text-sky-600 border-b-2 border-b-sky-600"
                : "text-gray-600",
              "font-semibold  px-4 py-2 hover:text-sky-600 ml-3 whitespace-nowrap"
            )
          }
        >
             {t("admin.calculation.setting.detail.tab.vehicleservices")}
        </NavLink>
      </div>
    </>
  );
};

export default memo(TabMenu);
